'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactSlidedown = require('react-slidedown');

var _slide = require('react-burger-menu/lib/menus/slide');

var _slide2 = _interopRequireDefault(_slide);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _IyvListMobileTable = require('./IyvListMobileTable.css');

var _IyvListMobileTable2 = _interopRequireDefault(_IyvListMobileTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListMobileSort = (_dec = (0, _reactCssModules2.default)(_IyvListMobileTable2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListMobileSort, _Component);

  //
  function IyvListMobileSort(props) {
    (0, _classCallCheck3.default)(this, IyvListMobileSort);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IyvListMobileSort.__proto__ || (0, _getPrototypeOf2.default)(IyvListMobileSort)).call(this, props));

    _this.renderBurger = function (isDesc) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: {
              fontSize: '0.875rem',
              display: 'flex',
              justifyContent: 'flex-start',
              width: '100%'
            } },
          _react2.default.createElement(
            'div',
            { style: {
                fontWeight: 800
              } },
            'SORT'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.LinkIcon, { faclass: isDesc ? 'fa-caret-down' : 'fa-caret-up' })
          )
        )
      );
    };

    _this.clickSortPanelButton = function (v) {
      var newState = {
        menuOpen: true,
        resultsShow: false,
        performanceShow: false,
        iyvShow: false
      };
      // if requested panel already showing, close them all
      if (!_this.state[v + 'Show']) {
        newState[v + 'Show'] = true;
      }
      _this.setState(newState);
    };

    _this.state = {
      sort: props.sort,
      isDesc: props.isDesc,
      menuOpen: false,
      resultsShow: true,
      performanceShow: false,
      iyvShow: false,
      labels: {
        'results': {
          'Fossil Free Funds': 'Fossil fuels',
          'Deforestation Free Funds': 'Deforestation',
          'Gender Equality Funds': 'Gender equality',
          'Gun Free Funds': 'Civilian firearms',
          'Prison Free Funds': 'Prison industrial complex',
          'Weapon Free Funds': 'Military weapons',
          'Tobacco Free Funds': 'Tobacco',
          'Invest Your Values': 'Sustainability'
        },
        'performance': 'Financial performance',
        'iyv': 'Sustainability'
      }
    };
    return _this;
  }
  //


  (0, _createClass3.default)(IyvListMobileSort, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({
        sort: props.sort,
        isDesc: props.isDesc
      });
    }
    //

    //

  }, {
    key: 'render',

    //
    value: function render() {
      var _this2 = this;

      var styles = {
        bmBurgerButton: {
          position: 'relative',
          // width: '1.25rem',
          // height: '1.1rem',
          // float: 'right',
          float: 'left',
          cursor: 'pointer'
        },
        bmBurgerBars: {
          background: '#333',
          cursor: 'pointer'
        },
        bmIcon: {
          whiteSpace: 'nowrap',
          fontSize: '1.5em',
          fontFamily: "Montserrat,'Helvetica Neue',Arial,sans-serif",
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        bmMenuWrap: {
          top: 0,
          zIndex: 10001,
          width: '100%',
          maxWidth: '100%',
          left: '0px'
        },
        bmCrossButton: {
          height: '1.6rem',
          width: '1.6rem',
          cursor: 'pointer'
        },
        bmCross: {
          background: '#333',
          cursor: 'pointer'
        },
        bmMenu: {
          background: 'white',
          padding: '0 2.5rem 0 0',
          fontSize: '1.15rem',
          borderLeft: '1px solid #A3A3A3'
        },
        bmMorphShape: {
          fill: 'white'
        },
        bmItemList: {
          color: '#333',
          padding: '0 1rem 1rem 1rem',
          boxSizing: 'border-box'
        },
        bmOverlay: {
          background: 'rgba(0, 0, 0, 0.76)',
          top: 0,
          right: 0,
          zIndex: 10000
        }
      };

      return _react2.default.createElement(
        'div',
        { styleName: 'ilmt-sort' },
        _react2.default.createElement(
          _slide2.default,
          {
            styles: styles,
            isOpen: this.state.menuOpen,
            burgerButtonClassName: '',
            disableOverlayClick: true,
            customBurgerIcon: this.renderBurger(this.props.isDesc)
          },
          _react2.default.createElement(
            'nav',
            null,
            _react2.default.createElement(
              'h2',
              null,
              'Sort by'
            ),
            (0, _keys2.default)(this.props.resultsTableColumns[_config2.default.app.title]).map(function (e, i) {
              var rows = _this2.props.resultsTableColumns[_config2.default.app.title][e];
              // skip first row if not first viewPanel.
              // to avoid showing fund name 3 times
              var _rows = rows;
              if (e === 'performance') {
                _rows = rows.slice(1, rows.length - 1);
              } else if (e === 'iyv') {
                _rows = rows.slice(1, rows.length);
              }

              return _react2.default.createElement(
                'div',
                { key: 'mobile-sort-' + i },
                _react2.default.createElement(
                  'button',
                  {
                    styleName: 'ilmt-item-switch',
                    onClick: function onClick() {
                      _this2.clickSortPanelButton(e);
                    }
                  },
                  e === 'results' ? _this2.state.labels[e][_config2.default.app.title] : _this2.state.labels[e],
                  _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: _this2.state[e + 'Show'] ? 'fa-angle-up' : 'fa-angle-down' })
                ),
                _react2.default.createElement(
                  _reactSlidedown.SlideDown,
                  null,
                  _this2.state[e + 'Show'] ? _rows.map(function (_e, _i) {
                    var name = _e[0];
                    var fieldName = _e[1];
                    return _react2.default.createElement(
                      'button',
                      {
                        styleName: 'ilmt-item ' + (_this2.state.sort === fieldName ? 'ilmt-item-active' : ''),
                        key: 'mobile-sort-' + i + '-' + _i,
                        onClick: function onClick() {
                          _this2.setState({
                            menuOpen: true,
                            sort: fieldName
                          });
                        }
                      },
                      name
                    );
                  }) : null
                )
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'ilmt-apply-ascending-buttons' },
            _react2.default.createElement(
              'button',
              {
                styleName: 'ilmt-apply-button',
                onClick: function onClick() {
                  _this2.props.clickColumnHeader(_this2.state.sort, _this2.state.isDesc ? 'desc' : 'asc')();
                }
              },
              'Apply'
            ),
            _react2.default.createElement(
              'button',
              {
                styleName: 'ilmt-ascending-button',
                onClick: function onClick() {
                  _this2.setState({
                    menuOpen: true,
                    isDesc: !_this2.state.isDesc
                  });
                }
              },
              this.state.isDesc ? 'Descending' : 'Ascending',
              _react2.default.createElement(_components.LinkIcon, { faclass: this.state.isDesc ? 'fa-caret-down' : 'fa-caret-up' })
            )
          )
        )
      );
    }
  }]);
  return IyvListMobileSort;
}(_react.Component), _class2.propTypes = {
  sort: _react.PropTypes.string,
  isDesc: _react.PropTypes.bool,
  clickColumnHeader: _react.PropTypes.func,
  resultsTableColumns: _react.PropTypes.object

}, _temp)) || _class);
exports.default = IyvListMobileSort;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListMobileTable/IyvListMobileSort.js
// module id = 1323
// module chunks = 0